// extracted by mini-css-extract-plugin
export default {"select":"Select_select__krzyQ","selectIcon":"Select_selectIcon__GSx2Y"};